const consul = require('./consul')(process.env);
const agent = require('./agent')(process.env);


const setPort = PORT => ({ PORT });
const setCDN = CDN => ({ CDN });
const setService = SERVICE_NAME => ({ SERVICE_NAME });
const setProduction = ENV => ({ PRODUCTION: ENV === 'production' });
const setLogsPath = LOGS_PATH => ({ LOGS_PATH });
const setJWKSUri = JWKS_URI => ({ JWKS_URI });
const setReleaseStage = RELEASE_STAGE => ({ RELEASE_STAGE });
const setConnectionTimeLimit = CONNECTION_TIME_LIMIT => ({ CONNECTION_TIME_LIMIT });
const setDomain = DOMAIN => ({ DOMAIN });
const setGateway = GATEWAY => ({ GATEWAY });
const setTracingAddress = TRACING_ADDRESS => ({ TRACING_ADDRESS });
const setNavigationEnvironment = NAVIGATION_ENVIRONMENT => ({ NAVIGATION_ENVIRONMENT });
const setApiTranslations = API_TRANSLATIONS => ({ API_TRANSLATIONS });

module.exports = {
  AGENT: agent,
  CONSUL: consul,
  ...setTracingAddress(process.env.TRACING_ADDRESS),
  ...setService(process.env.SERVICE_NAME),
  ...setPort(Number(process.env.PORT)),
  ...setConnectionTimeLimit(process.env.CONNECTION_TIME_LIMIT),
  ...setProduction(process.env.NODE_ENV),
  ...setLogsPath(process.env.LOGS_PATH),
  ...setCDN(process.env.CDN),
  ...setJWKSUri(process.env.JWKS_URI),
  ...setReleaseStage(process.env.RELEASE_STAGE),
  ...setDomain(process.env.DOMAIN),
  ...setGateway(process.env.GATEWAY),
  ...setNavigationEnvironment(process.env.NAVIGATION_ENVIRONMENT),
  ...setApiTranslations(process.env.API_TRANSLATIONS)
};
